import React, { Fragment, useEffect } from 'react';

// Components

import ModalHeader from '../headers/ModalHeader';

// Utils

import { preventerTools } from '../../../utils/tools/preventerTools';



const LocateAssistanceModal = props => {

    const {
        actions: {
            hideModal
        },
        modal: {
            modalData
        },
        modalHeaderProps
    } = props;
    
    const {
        customEvent
    } = preventerTools.provideObject(modalData);

    useEffect(() => {
        if(customEvent) {
            const closeModalFromIframe = e => {
                if(e.detail.event === customEvent) {
                    hideModal();
                }
            };
            window.customEvent = customEvent;
            window.addEventListener(customEvent, closeModalFromIframe);
            return () => {
                delete window.customEvent;
                window.removeEventListener(customEvent, closeModalFromIframe);
            };
        }
    }, [ ]);

    return (
        <Fragment>
            <ModalHeader { ...modalHeaderProps }/>
            <div className="gi-modal__body locate-assistance-modal" id = 'locateAssistanceModal'>
                <iframe id="brokersearchBox" src="/hix/broker/search" title="Find Local Assistance" className="searchModal-body"></iframe>
            </div>
        </Fragment>
    );
};

export default LocateAssistanceModal;
